/**
 * Etiqueta de la situación de un registro RECPO.
 *
 * El padrón del MINEM trae `Situation = "Completo"` en el 100% de las filas (14.702 de
 * 14.702 en dev): describe que la ficha del padrón está completa, no la situación del
 * minero. Mostrado tal cual no informaba nada y el cliente lo reportó como ambiguo.
 *
 * Se traduce a "Registrado", que es lo que el dato realmente significa para el
 * evaluador: este RUC figura en el padrón de comercializadores y procesadores de oro.
 * Cualquier otro valor que el padrón llegue a traer se muestra sin tocar.
 */
export function etiquetaSituacionRecpo(situation: string | null | undefined): string {
  const valor = situation?.trim()
  if (!valor) return 'Sin registro'
  return valor.toLowerCase() === 'completo' ? 'Registrado' : valor
}
